import { render, staticRenderFns } from "./novelMiniprogramlist.vue?vue&type=template&id=fcb95bfc&scoped=true"
import script from "./novelMiniprogramlist.vue?vue&type=script&lang=js"
export * from "./novelMiniprogramlist.vue?vue&type=script&lang=js"
import style0 from "./novelMiniprogramlist.vue?vue&type=style&index=0&id=fcb95bfc&prod&scoped=true&lang=less"
import style1 from "./novelMiniprogramlist.vue?vue&type=style&index=1&id=fcb95bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb95bfc",
  null
  
)

export default component.exports